import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  heading: 'Căutare',
  resultsSummary: 'rezultate pentru',
  noResultsPrefix: 'Niciun rezultat pentru',
  noResultsRetry: 'Încercați alți termeni.',
  noResultsHint: 'Verificați ortografia sau folosiți cuvinte mai generale.',

  typeNews: 'Știre',
  typeArticle: 'Articol',
  typePolicy: 'Politică',
  typePage: 'Pagină',
  typeAdvisor: 'Consilier',
  typeLibrary: 'Resursă bibliotecă',
  typeOrganization: 'Organizație',
  typeEvent: 'Eveniment',
  typeResearch: 'Proiect de cercetare',
  typeFunding: 'Măsură de finanțare',
  typeTraining: 'Instruire',

  contactHeading: 'Contact',
  contactEyebrow: 'Suport',
  contactIntro: 'Completează formularul și îți vom răspunde la adresa de e-mail indicată.',
  contactName: 'Nume',
  contactNamePlaceholder: 'Nume și prenume',
  contactEmail: 'E-mail',
  contactEmailPlaceholder: 'nume@exemplu.md',
  contactSubject: 'Subiect',
  contactSubjectPlaceholder: 'Despre ce ne scrii',
  contactMessage: 'Mesaj',
  contactMessagePlaceholder: 'Descrie solicitarea',
  contactSend: 'Trimite',
  contactSending: 'Se trimite…',
  contactSuccess: 'Mesajul a fost trimis.',
  contactInvalid: 'Verificați datele introduse — adresa de e-mail pare incorectă.',
  contactError: 'Eroare — reîncercați.',
  contactPrivacyNotice:
    'Datele completate mai sus sunt prelucrate de Ministerul Agriculturii și Industriei Alimentare exclusiv pentru a înregistra și a răspunde solicitării dumneavoastră, conform Legii nr. 133/2011 privind protecția datelor cu caracter personal și GDPR. Aveți dreptul de acces, rectificare și ștergere a acestor date.',
  contactPrivacyLink: 'Politica de confidențialitate',
} as const;

const en = {
  heading: 'Search',
  resultsSummary: 'results for',
  noResultsPrefix: 'No results for',
  noResultsRetry: 'Try different terms.',
  noResultsHint: 'Check your spelling or use more general words.',

  typeNews: 'News item',
  typeArticle: 'Article',
  typePolicy: 'Policy',
  typePage: 'Page',
  typeAdvisor: 'Adviser',
  typeLibrary: 'Library resource',
  typeOrganization: 'Organisation',
  typeEvent: 'Event',
  typeResearch: 'Research project',
  typeFunding: 'Funding measure',
  typeTraining: 'Training',

  contactHeading: 'Contact',
  contactEyebrow: 'Support',
  contactIntro: 'Fill in the form and we will reply to the address you give.',
  contactName: 'Name',
  contactNamePlaceholder: 'First and last name',
  contactEmail: 'Email',
  contactEmailPlaceholder: 'name@example.md',
  contactSubject: 'Subject',
  contactSubjectPlaceholder: 'What you are writing about',
  contactMessage: 'Message',
  contactMessagePlaceholder: 'Describe your request',
  contactSend: 'Send',
  contactSending: 'Sending…',
  contactSuccess: 'Your message has been sent.',
  contactInvalid: 'Check the details — the email address looks incorrect.',
  contactError: 'Something went wrong — please try again.',
  contactPrivacyNotice:
    'The details entered above are processed by the Ministry of Agriculture and Food Industry solely to register and answer your request, under Law no. 133/2011 on the protection of personal data and the GDPR. You have the right to access, correct and erase this data.',
  contactPrivacyLink: 'Privacy policy',
} satisfies Translation<keyof typeof ro>;

export const publicSearch = { ro, en } satisfies Dictionary;

export type PublicSearchKey = keyof typeof ro;
